/**
 * Configurazione paginazione dashboard
 *
 * Quando `serverSidePagination` è true:
 * - Le chiamate API passano page e size
 * - I totali vengono calcolati solo alla prima pagina (caricaTotali)
 * - Si usa ServerSidePaginator
 *
 * Quando `serverSidePagination` è false:
 * - Le chiamate API passano size=undefined (recupera tutti i dati)
 * - La paginazione viene gestita lato client con usePagination
 * - Si usa AppPaginator
 */
export const dashboardConfig = {
  /** Abilita paginazione server-side per la tab Projects */
  projectsServerSidePagination: false,

  /** Abilita paginazione server-side per la tab Resource Planning (People) */
  peopleServerSidePagination: false,

  /** Abilita paginazione server-side per la tab Underbooking/Overbooking */
  bookingServerSidePagination: false,

  /** Abilita paginazione server-side per la tab SAL Planning */
  salPlanningServerSidePagination: false,

  /** Dimensione pagina di default */
  defaultPageSize: 50,
};
